import {Component, Input} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {TranslocoService} from "@ngneat/transloco";
import {
  CompetitorInfoDTO, CompetitorRegistrationDto, Lookups,
  Race,
  RaceCommercialItem, RegisterToRaceFormType, RegistrationType
} from "@model";
import {CurrencyPipe} from "@pipes";

@Component({
  selector: 'app-register-to-race-fee-item-output',
  templateUrl: './register-to-race-fee-item-output.component.html',
  styleUrls: ['./register-to-race-fee-item-output.component.scss'],
  animations: [
    trigger('fadeInAnimation', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(1600)
      ])
    ])]
})
export class RegisterToRaceFeeItemOutputComponent {
  @Input() eventCurrencyLabel: string | undefined;
  @Input() defaultLanguage?: number;
  @Input() race: Race | undefined;
  @Input() competitorRegistrationSummaryItem: CompetitorRegistrationDto | CompetitorInfoDTO | undefined;
  @Input() raceCommercialItems: RaceCommercialItem[] = [];
  @Input() registerToRaceFormType: RegisterToRaceFormType = RegisterToRaceFormType.REGISTRATION_INFO;
  @Input({required:true}) languages: Lookups[] = [];

  constructor(private currencyPipe: CurrencyPipe, public translocoService: TranslocoService) {
  }

  getRaceCommercialItemPrice(raceCommercialItem: RaceCommercialItem | undefined): string {
    let price: string = "";
    if (raceCommercialItem?.price !== undefined) {
      price = this.currencyPipe.transform(raceCommercialItem.price) + " " + this.eventCurrencyLabel;
    }
    return price;
  }

  protected readonly RegistrationType = RegistrationType;
  protected readonly RegisterToRaceFormType = RegisterToRaceFormType;
}
